import { type ApiClient, listQueryParams } from "./client";
import type { ListQuery, NewOrganization, OrganizationDetail, OrganizationFilters, OrganizationPatch, OrganizationRow, Page } from "./types";

/** Organizations: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface OrganizationsApi {
  list(query: ListQuery<OrganizationFilters>): Promise<Page<OrganizationRow>>;
  get(id: string): Promise<OrganizationDetail>;
  update(id: string, patch: OrganizationPatch): Promise<OrganizationDetail>;
  suspend(id: string, reason: string): Promise<OrganizationDetail>;
  reactivate(id: string): Promise<OrganizationDetail>;
  create(input: NewOrganization): Promise<OrganizationDetail>;
  /** Removes someone from the organization and all its stores. */
  removeMember(organizationId: string, userId: string): Promise<void>;
}

export function createHttpOrganizationsApi(client: ApiClient): OrganizationsApi {
  return {
    list: (q) => client.call("listOrganizations", { query: listQueryParams(q) }),
    get: (id) => client.call("getOrganization", { params: { id } }),
    update: (id, patch) => client.call("updateOrganization", { params: { id }, body: patch }),
    suspend: (id, reason) => client.call("suspendOrganization", { params: { id }, body: { reason } }),
    reactivate: (id) => client.call("reactivateOrganization", { params: { id } }),
    create: (input) => client.call("createOrganization", { body: input }),
    removeMember: async (organizationId, userId) => {
      await client.call("removeOrganizationMember", { params: { id: organizationId, userId } });
    },
  };
}
